/**
 * FILE: src/blueprint/components/report/CardBlock.jsx
 */

import TextBlock from './TextBlock.jsx';
import TitleBlock from './TitleBlock.jsx';

function asString(value) {
  return typeof value === 'string' ? value : '';
}

export default function CardBlock({
  title = '',
  body = '',
  value = '',
  format = 'plain',
  className = '',
}) {
  const resolvedTitle = asString(title).trim();
  const resolvedBody = asString(body).trim() || asString(value).trim();

  if (!resolvedTitle && !resolvedBody) {
    return null;
  }

  const cardClassName = ['dv-block-renderer__card', className].filter(Boolean).join(' ');

  return (
    <div className={cardClassName}>
      {resolvedTitle ? <TitleBlock value={resolvedTitle} level={3} /> : null}
      {resolvedBody ? <TextBlock value={resolvedBody} format={format} /> : null}
    </div>
  );
}
